import { render, staticRenderFns } from "./LogoFscComponent.vue?vue&type=template&id=cef3efb0&scoped=true&"
import script from "./LogoFscComponent.vue?vue&type=script&lang=ts&"
export * from "./LogoFscComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef3efb0",
  null
  
)

export default component.exports